<template>
  <vs-chip class="ag-grid-cell-chip" :color="statusColor">
    <span><feather-icon :icon="statusIcon" :size="5" /></span>
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererGutCheck',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusIcon() {
      return this.status === 'normal' ? 'CheckIcon' : 'AlertTriangleIcon'
    },
    statusColor() {
      return this.status === 'normal' ? 'success' : 'warning'
    }
  }
}
</script>

<style lang="scss" scoped>
.ag-grid-cell-chip {
  .text-chip {
    margin: 0 !important;
  }
}
</style>
